import { addDays, format } from 'date-fns';
import { Pipe, PipeTransform } from '@angular/core';
import { Manco, MancoToCheckUpOn } from '../manco-to-check-up-on';

export enum MancoFilters {
  AllMancos = "Alle manco's",
  MancosNext3Days = "Manco's voor komende 3 dagen",
}

export enum MancoFilterOptions {
  None,
  DoubleReturns,
  OpenMancosWithKrampReturnNumber,
}

@Pipe({
  name: 'mancoFilter',
})
export class MancoFilterPipe implements PipeTransform {
  transform(
    mancos: MancoToCheckUpOn[],
    selectedFilter: MancoFilters,
    returnRegisteredAwaitingDeliveryFilter: boolean,
    openMancoWithKrampReturnNumberFilter: boolean
  ): MancoToCheckUpOn[] {
    const newDate = addDays(this.today(), 4);
    const checkDate = format(newDate, 'yyyy-MM-dd');

    return mancos.filter((manco: Manco) => {
      // Base filter: Apply selectedFilter logic
      const baseFilter =
        selectedFilter === MancoFilters.AllMancos || (!manco.completed && manco.checkDate <= checkDate);

      // Returns filter: Apply only if returnRegisteredAwaitingDeliveryFilter is true
      const returnsFilter = !returnRegisteredAwaitingDeliveryFilter || (!!manco.returnNumber && !manco.returnReceived);

      // Open manco with kramp return number filter: Apply only if openMancoWithKrampReturnNumberFilter is true
      const OpenKrampReturnsFilter =
        !openMancoWithKrampReturnNumberFilter || (!!manco.returnNumber && !manco.completed);

      return baseFilter && returnsFilter && OpenKrampReturnsFilter;
    });
  }

  today(): Date {
    return new Date();
  }
}
